module.exports = __webpack_public_path__ + "img/tu3.83935838.png";